// © Microsoft Corporation. All rights reserved.
// IF YOU UPDATE THIS FILE PLEASE UPDATE THE ONE IN WebWorker
// DUE TO TREE SHAKING ISSUES WHEN IN DEBUG WE CAN'T USE COMMON CODE
// WITHOUT CAUSING ISSUES IN WebWorker

/** Helper class to work on URL search params */
export class UrlSearchParamsHelper {
    /** Object that contains all the query strings */
    private searchParams: { [index: string]: string } = Object.create(null);

    constructor(search?: string) {
        this.parseQueryString(search);
    }

    /**
     * Sets the query string value
     * @param name query string name
     * @param value query string value
     */
    public set(name: string, value: string): UrlSearchParamsHelper {
        if (value !== undefined && value !== null) {
            this.searchParams[name] = value;
        }

        return this;
    }

    /**
     * Gets the query string value
     * @param name query string name
     */
    public get(name: string): string {
        return this.searchParams[name];
    }

    /**
     * Deletes the query string value
     * @param name query string name
     */
    public delete(name: string): void {
        delete this.searchParams[name];
    }

    /**
     * Returns the query parameters as a string
     */
    public toString(): string {
        const keys = Object.keys(this.searchParams);

        if (!keys.length) {
            return "";
        }

        return keys.sort().map((key: string) => {
            return `${key}=${this.searchParams[key]}`;
        }).join("&");
    }

    /** Parses the query string and adds the values to searchParams */
    private parseQueryString(queryString?: string): void {
        if (!queryString) {
            return;
        }

        if (queryString.charAt(0) === "?") {
            queryString = queryString.substring(1);
        }

        queryString.split("&").forEach((keyValuePairs) => {
            const query = keyValuePairs.split("=");

            const name = query[0];

            if (!this.get(name)) {
                this.searchParams[name] = query[1];
            }
        });
    }
}